import React from "react"
import { RouteComponentProps } from "@reach/router"
import logo from "../../components/Navigation/logo.svg"
import styles from "./IENotCompatible.scss"

const IENotCompatiblePage = ({  }: RouteComponentProps) => (
  <div className={styles.maintenanceContainer}>
    <div>
      <div>
        <img src={logo} alt="logo" />
      </div>
      Nous ne supportons pas internet explorer :/
      <br />
      Visitez-nous sur Chrome, Opera, Firefox ou Edge !
    </div>
  </div>
)

export default IENotCompatiblePage
